import { SvgIcon, SvgIconProps } from "@mui/material";
import type { JSX } from "react";

export const MarketAnalysisIcon = (props: SvgIconProps): JSX.Element => (
  <SvgIcon viewBox="0 0 45 45" fill="none" {...props}>
    {/* Outer circle */}
    <path
      d="M22.5 0.75C34.5122 0.75 44.25 10.4878 44.25 22.5C44.25 34.5122 34.5122 44.25 22.5 44.25C10.4878 44.25 0.75 34.5122 0.75 22.5C0.75 10.4878 10.4878 0.75 22.5 0.75Z"
      stroke="currentColor"
      strokeOpacity="0.4"
      strokeWidth="1.5"
      fill="none"
    />

    {/* Currency / investment symbol */}
    <path
      d="M13.2088 25.625H12.6049L12.0838 26.6664H13.1252V27.7078H12.6041L12.083 28.7492H13.208C13.5775 31.0516 15.2447 32.3953 17.8119 32.3953H19.3744V31.3539H17.8119C16.6143 31.3539 14.6869 30.9844 14.265 28.75H16.7705L17.2916 27.7086H14.1666V26.6672H16.7705L17.2916 25.6258H14.2658C14.6877 23.3656 16.615 23.0219 17.8127 23.0219H19.3752V21.9805H17.8127C15.2447 21.9805 13.5783 23.3031 13.2088 25.6266V25.625Z"
      fill="currentColor"
    />

    {/* Circle detail */}
    <path
      d="M22.5 20.416C23.3633 20.416 24.0625 19.7168 24.0625 18.8535C24.0625 17.9902 23.3633 17.291 22.5 17.291C21.6367 17.291 20.9375 17.9902 20.9375 18.8535C20.9375 19.7168 21.6367 20.416 22.5 20.416ZM22.5 18.3332C22.7875 18.3332 23.0211 18.566 23.0211 18.8543C23.0211 19.1426 22.7883 19.3754 22.5 19.3754C22.2125 19.3754 21.9789 19.1426 21.9789 18.8543C21.9789 18.5668 22.2117 18.3332 22.5 18.3332Z"
      fill="currentColor"
    />

    {/* House */}
    <path
      d="M33.9577 18.3334L22.4991 12.6045L11.0405 18.3334L11.5093 19.2654L13.6444 18.1717V21.4584L14.6858 20.9373V17.6506L22.4983 13.7498L30.3108 17.6561V31.3537H26.1444V26.6662C26.1429 24.6537 24.5116 23.0225 22.4983 23.0225C21.9304 23.0225 21.3929 23.1522 20.914 23.3834L20.9358 23.374L21.4046 24.3061C21.7249 24.1537 22.1007 24.0639 22.4976 24.0615C23.9358 24.0615 25.1022 25.2271 25.1022 26.6654V31.3529H21.4562L20.9351 32.3943H31.3515V18.1756L33.4921 19.2436L33.9577 18.3334Z"
      fill="currentColor"
    />
  </SvgIcon>
);
